import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';

export function useFormWithSchema({ schema, shouldUnregister }: { schema: any; shouldUnregister?: boolean }) {
  return useForm({
    resolver: joiResolver(schema),
    shouldUnregister: shouldUnregister === undefined ? true : shouldUnregister,
  });
}
